"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var CodeGenerator = function () {
    function CodeGenerator(client, environment, endpointUrl) {
        this.client = client;
        this.environment = environment;
        this.endpointUrl = endpointUrl;
    }
    CodeGenerator.prototype.getSetup = function () {
        var template = "$ npm install ";
        if (this.client === 'lokka') {
            return template + "lokka lokka-transport-http";
        } else if (this.client === 'fetch') {
            return template + "isomorphic-fetch es6-promise";
        }
        return '';
    };
    CodeGenerator.prototype.getCode = function (query) {
        return this.getImports() + this.getTransport() + '\n' + this.getQueryCode(query);
    };
    CodeGenerator.prototype.getTransport = function () {
        if (this.client === 'lokka') {
            return "\nconst headers = {\n  Authorization: 'Bearer YOUR_AUTH_TOKEN'\n}\n\nconst client = new Lokka({\n  transport: new Transport('" + this.endpointUrl + "', {headers})\n});\n";
        }
        return '';
    };
    CodeGenerator.prototype.getImports = function () {
        if (this.client === 'lokka' && this.environment === 'Node') {
            return "const Lokka = require('lokka').Lokka;\nconst Transport = require('lokka-transport-http').Transport;\n";
        } else if (this.client === 'lokka' && this.environment === 'Browser') {
            return "import {Lokka} from 'lokka'\nimport {Transport} from 'lokka-transport-http'\n";
        } else if (this.client === 'fetch') {
            return "require('es6-promise').polyfill()\nrequire('isomorphic-fetch')\n";
        }
        return '';
    };
    CodeGenerator.prototype.getQueryCode = function (query) {
        if (query.includes('mutation')) {
            return this.getMutation(query);
        } else {
            return this.getQuery(query);
        }
    };
    CodeGenerator.prototype.getQuery = function (query) {
        if (this.client === 'lokka') {
            return "function getItems() {\n  return client.query(`\n  " + query.split('\n').map(function (line, i) {
                return '    ' + line;
            }).join('\n') + "\n  `)\n}";
        }
        if (this.client === 'fetch') {
            return "function getItems() {" + this.getFetchBody(query) + "}";
        }
        return '';
    };
    CodeGenerator.prototype.getFetchBody = function (query) {
        var jsonQuery = JSON.stringify({
            query: query
        });
        return "\n    return fetch('" + this.endpointUrl + "', {\n      method: 'post',\n      headers: {\n        'Content-Type': 'application/json',\n      //   'Authorization': 'Bearer YOUR_AUTH_TOKEN'\n      },\n      body: '" + jsonQuery + "',\n    })\n";
    };
    CodeGenerator.prototype.getMutation = function (query) {
        var curlyIndex = query.indexOf('{');
        var strippedQuery = query.slice(curlyIndex, query.length);
        if (this.client === 'lokka') {
            return "function setItem() {\nreturn client.mutate(`\n" + strippedQuery.split('\n').map(function (line, i) {
                return '    ' + line;
            }).join('\n') + "\n  `)\n}";
        }
        if (this.client === 'fetch') {
            return "function setItem() {" + this.getFetchBody(query) + "}";
        }
        return '';
    };
    return CodeGenerator;
}();
exports.CodeGenerator = CodeGenerator;


//////////////////
// WEBPACK FOOTER
// ./~/graphcool-graphiql/babelbuild/CodeGenerationPopup/codeGeneration.js
// module id = ./node_modules/graphcool-graphiql/babelbuild/CodeGenerationPopup/codeGeneration.js
// module chunks = 0